import { createFileRoute } from "@tanstack/react-router";
import { AcceptInvitation } from "./-accept/AcceptInvitation";

/** The link in a workspace invitation email: `/invitations/accept?token=…`. */
export const Route = createFileRoute("/invitations/accept")({
  validateSearch: (s: Record<string, unknown>): { token?: string } => (typeof s.token === "string" && s.token ? { token: s.token } : {}),
  staticData: { title: "Join a workspace" },
  component: AcceptInvitation,
});
